import {createSlice} from '@reduxjs/toolkit';
import {config} from '../config';
import {callBackend, downloadCSV} from "./utils";

const EXPORT_API_URL = `${config.API_URL}/download`;

export const articleSelector = createSlice({
  name: 'articleSelector',
  initialState: {
    selectedArticles: [],
    titleIdMap: {}
  },
  reducers: {
    selectArticle: (state, action) => {
      const id = action.payload.id;
      state.titleIdMap[id] = action.payload.title;
      if (!state.selectedArticles.includes(id)) state.selectedArticles.push(id);
    },

    unselectArticle: (state, action) => {
      const id = action.payload.id;
      delete state.titleIdMap[id]
      state.selectedArticles = state.selectedArticles.filter(item => item !== id);
    },

    downloadSelected: state => {
      if (state.selectedArticles.length > 0) {
        callBackend(EXPORT_API_URL, {ids: state.selectedArticles}, 'blob').then(res => downloadCSV(res));
      }
    },
  },
});

const { selectArticle, unselectArticle, downloadSelected } = articleSelector.actions;

export { selectArticle, unselectArticle, downloadSelected };
export const articleSelectorReducer = articleSelector.reducer;
